import * as React from 'react';
import { useParams } from 'react-router-dom';
import {
  TextInput,
  BooleanInput,
  Create,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  useGetOne,
} from 'react-admin';

export const CourseClone = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetOne('courses', { id });

  if (isLoading) {
    return null;
  }

  return (
    <Create
      title={`Cloning: ${data.code} ${data.title}`}
      resource={`courses/${data.originId}/clone`}
      redirect={`/courses`}
      transform={(data) => JSON.stringify(data)}
    >
      <SimpleForm sanitizeEmptyValues={true} defaultValues={{}}>
        <ReferenceInput
          source={'cloneIntoCompany'}
          reference={'companies'}
          name={'Company'}
        >
          <SelectInput
            required
            source={'cloneIntoCompany'}
            reference={'companies'}
            optionText={'name'}
            id="cloneIntoCompany"
          />
        </ReferenceInput>
        <TextInput
          required
          label="New Code"
          source="cloneCode"
          id="cloneCode"
        />
        <BooleanInput
          label="With Course Cities"
          source="cloneWithCourseCities"
          id="cloneWithCourseCities"
        />
        <BooleanInput
          label="With Course City Dates"
          source="cloneWithCourseCityDates"
          id="cloneWithCourseCityDates"
        />
      </SimpleForm>
    </Create>
  );
};
